import { map as _map } from 'lodash';
import { filter as _filter } from 'lodash';
import { find as _find } from 'lodash';
import { sortBy as _sortBy } from 'lodash';
import { without as _without } from 'lodash';
import VehicleLookupTemplate from './vehicleLookup.modal.html';

class VehicleInformationController {
  constructor(lookupService, authService, enums, $q, loadingService, $uibModal, $scope, appConfig) {
    "ngInject";

    this.lookupService = lookupService;
    this.authService = authService;
    this.enums = enums;
    this.$q = $q;
    this.loadingService = loadingService;
    this.$uibModal = $uibModal;
    this.$scope = $scope;

    this.initializeEnumLookups();
    this.initializeMyLocations();    

    this.searchRetailPriceListUrl = `${appConfig.apiServiceBaseUri}api/retailPriceList/search/`;
    
    this.dtPopups = {}; //Cleanup

    this.panels = {
      vehicleInformation: true
    }

    this.panels = [];
    this.panels['basic'] = {visible: true};
    this.panels['more'] = {visible: false};
    this.panels['notes'] = {visible: false};

    $scope.selectVehicle = this.selectVehicle.bind(this);
    this.vehicleSelected = this.vehicleSelected.bind(this);

    $scope.$watch("$ctrl.extras['Previous Owners']", (newValue, oldValue) => {      
      if (newValue && Number.isInteger(parseInt(newValue))) {
        if (!this.extras['Current Owners']) {
          this.extras['Current Owners'] = parseInt(newValue) + 1;
        }        
      }
      else{
        this.extras['Current Owners'] = null;
      }
    });

    this.$scope.$on('vehicle:initialized',this.updateSelectDefaults.bind(this));    
  }

  initializeLookups(updateBrandModels = true) {
    const ctrl = this;
    const deferred = ctrl.$q.defer();

    if (!ctrl.selectDefaults.vehicleCondition.id) {
      this.brands = [];
      this.selectDefaults.brand = null
      this.brandModels = [];
      this.selectDefaults.brandModel = null
      return;
    }

    this.lookupService.lookupBrands()
      .then(brands => {
        //Remove 'All Brands' item from this list
        brands.shift();

        this.allBrands = brands;

        //If New Vehicle then filter brands with only allowed brands on roles in this location
        if (ctrl.selectDefaults.vehicleCondition.id === 1) {
          const allowedBrands = ctrl.authService.getLocationBrands(ctrl.enums.PERMISSION_TYPE.Add);
          const hasAllBrand = _find(allowedBrands, brandId => brandId === 1);

          if (hasAllBrand) {
            this.brands = brands;
          }
          else {
            this.brands = _filter(brands, o => {
              return _find(allowedBrands, brandId => brandId === o.brandId) !== undefined;
            })
          }
        }
        else {
          this.brands = brands;
        }

        this.selectDefaults.brand = this.brands[0];

        this.lookupService.lookupBrandModels()
          .then(brandModels => {
            this.allBrandModels = brandModels;
            if (updateBrandModels) {
              this.updateBrandModel();
            }
            deferred.resolve();
          });
      });

      return deferred.promise;
  }

  initializeEnumLookups() {
    const ctrl = this;
    ctrl.selectDefaults = {};

    const lookups = ['VehicleType', 'AutoSold', 'MileageType', 'VehicleCondition', 'VehicleBodyType', 'Color', 'FuelType', 'TransmissionType', 'VehicleStatus'];
    this.enumLookupCollection = [];

    this.lookupService.lookupEnums(lookups)
      .then(enumLookupCollection => {
        if (enumLookupCollection.vehicleBodyType) {
          //Sort Vehicle Body List Bug Id 3263
          enumLookupCollection.vehicleBodyType = _sortBy(enumLookupCollection.vehicleBodyType, o => o.name);
        }

        this.enumLookupCollection = enumLookupCollection;

        _map(enumLookupCollection, (itemsArray, index) => {
          //Add New for Price List option
          if (index === 'vehicleCondition') {
            itemsArray.unshift({id: 3, name: 'New (From Price List)'});
          }
          
          //Add the Please Select option for the Dropdowns
          if (index !== 'vehicleType' && index !== 'autoSold') {
            itemsArray.unshift({id: null, name: 'Please Select'});
          }

          this.selectDefaults[index] = itemsArray[0];

          this.updateModelFromSelect(index);
        });

        //First Component Ready
        this.onComponentReady();
      });
  }

  initializeMyLocations() {
    this.lookupService.lookupMyLocations(this.authService.authData.currentLocation.key)
      .then(response => {
        this.myLocations = response.data;
      });  
  }

  showDatePopup(id) {
    this.dtPopups[id] = true;
  }

  updateBrandModel() {
    this.brandModels = _filter(this.allBrandModels, o => o.brandId === this.selectDefaults.brand.brandId);
    this.selectDefaults.brandModel = this.brandModels[0];
    this.updateModelFromSelect('brandModelId','brandModel','brandModelId');
  }

  updateModelFromSelect(modelProperty, selectDefaultProperty = modelProperty, idProperty = 'id') {
    this.vehicle[modelProperty] = this.selectDefaults[selectDefaultProperty][idProperty];

    if (modelProperty === 'vehicleCondition') {
      this.initializeLookups();
    }
  }

  updateSelectDefaults() {
    const ctrl = this;

    _map(ctrl.selectDefaults, (index, item) => {
        let editSelectDefault;

        if (item === 'vehicleStatus') {
          editSelectDefault = _find(ctrl.enumLookupCollection[item], o => o.id === ctrl.vehicle.state);
        }
        else {
          editSelectDefault = _find(ctrl.enumLookupCollection[item], o => o.id === ctrl.vehicle[item]);
        }

        if (editSelectDefault) {
          ctrl.selectDefaults[item] = editSelectDefault;
        }
        else {
          if (ctrl.enumLookupCollection[item]) {
            ctrl.selectDefaults[item] = ctrl.enumLookupCollection[item][0];
          }
        }
    });
    ctrl.initializeLookups(false)
      .then(() => {
        const editBrand = _find(ctrl.brands, o => o.brandId === ctrl.vehicle.brandId);
        ctrl.selectDefaults.brand = editBrand;

        const tempBrandModelId = ctrl.vehicle.brandModelId;
        ctrl.updateBrandModel();
        const editBrandModel = _find(ctrl.brandModels, o => o.brandModelId === tempBrandModelId);
        ctrl.selectDefaults.brandModel = editBrandModel;
        ctrl.updateModelFromSelect('brandModelId','brandModel','brandModelId');
      });
  }

  lookupVehicle() {
    const ctrl = this;
    
    if (ctrl.selectDefaults.vehicleCondition.id === 0 || !ctrl.vehicle.registration) {return ;}

    ctrl.loadingService.showLoading('vehicleInfo', 'Loading Vehicle Information');

    ctrl.lookupService.lookupVehicleByRegNo(ctrl.authService.authData.currentLocation.key, ctrl.vehicle.vehicleCondition, ctrl.vehicle.registration)
      .then(response => {        
        ctrl.$scope.lookupData = ctrl.getVehicleViewModel(response.data);
        ctrl.$scope.brandModels = ctrl.getBrandModels(response.data.brandId);
        ctrl.$scope.errMsg = '';
        ctrl.lookupModalInstance = ctrl.$uibModal.open({
          template: VehicleLookupTemplate,
          scope: ctrl.$scope
        });
      })
      .catch(err => {
        if (err.status === 500) {
          ctrl.$scope.lookupData = {};
          ctrl.$scope.errMsg = err.data.exceptionMessage;
          ctrl.lookupModalInstance = ctrl.$uibModal.open({
            template: VehicleLookupTemplate,
            scope: ctrl.$scope
          });
        }
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('vehicleInfo');
      });
  }

  getVehicleViewModel(vehicleEditViewModel) {
    let vehicleVM = {};

    vehicleVM.make = _find(this.allBrands, o => o.brandId === vehicleEditViewModel.brandId).name;
    vehicleVM.brandId = vehicleEditViewModel.brandId;

    vehicleVM.model = vehicleEditViewModel.brandModelId ? _find(this.allBrandModels, o => o.brandModelId === vehicleEditViewModel.brandModelId).name : '';
    vehicleVM.brandModelId = vehicleEditViewModel.brandModelId;

    vehicleVM.variant = vehicleEditViewModel.variant;
    vehicleVM.variantCode = vehicleEditViewModel.variantCode;
    vehicleVM.registration = vehicleEditViewModel.registration;
    vehicleVM.chassisNo = vehicleEditViewModel.chassisNo;
    vehicleVM.engineNo = vehicleEditViewModel.engineNo;
    vehicleVM.firstRegistration = vehicleEditViewModel.firstRegistration;

    vehicleVM.year = vehicleEditViewModel.year;

    if (vehicleEditViewModel.capacity && vehicleEditViewModel.capacity.toString().length === 1) {
      vehicleVM.capacity = vehicleEditViewModel.capacity + '.0';
    }
    else {
      vehicleVM.capacity = vehicleEditViewModel.capacity;
    }

    vehicleVM.color = vehicleEditViewModel.color;
    vehicleVM.colorName = _find(this.enumLookupCollection.color, o => o.id === vehicleEditViewModel.color).name;

    vehicleVM.vehicleBodyType = vehicleEditViewModel.vehicleBodyType;
    vehicleVM.vehicleBodyTypeName = _find(this.enumLookupCollection.vehicleBodyType, o => o.id === vehicleEditViewModel.vehicleBodyType).name;

    vehicleVM.transmissionType = vehicleEditViewModel.transmissionType;
    vehicleVM.transmissionTypeName = _find(this.enumLookupCollection.transmissionType, o => o.id === vehicleEditViewModel.transmissionType).name;

    vehicleVM.fuelType = vehicleEditViewModel.fuelType;
    vehicleVM.fuelTypeName = _find(this.enumLookupCollection.fuelType, o => o.id === vehicleEditViewModel.fuelType).name;

    vehicleVM.extras = vehicleEditViewModel.extras;

    return vehicleVM;
  }

  getBrandModels(brandId){
    let brandModels = _filter(this.allBrandModels, o => o.brandId === brandId);

    brandModels.unshift({brandModelId: null, brandId: brandId, name: 'Please Select'});

    return brandModels;
  }

  selectVehicle(update) {
    const ctrl = this;

    if (update) {      
      if (!ctrl.$scope.lookupData.brandModelId) {
        alert('Please select the model first');
        return;
      }

      Object.assign(ctrl.vehicle, ctrl.$scope.lookupData);
      if (ctrl.vehicle.firstRegistration) {
        ctrl.vehicle.firstRegistration = new Date(ctrl.vehicle.firstRegistration);
      }

      ctrl.updateSelectDefaults();
      ctrl.onLookupVehicleSelected();
    }

    ctrl.lookupModalInstance.close();
  }

  vehicleSelected(item)
  {
    if (item) {
      this.vehicle.vehicleCondition = 1;

      let selectedBrand = _find(this.allBrands, o => o.brandId === item.originalObject.brandId);
      this.selectDefaults.brand = selectedBrand;

      this.updateBrandModel();
      let selectedModel = _find(this.brandModels, o => o.brandModelId === item.originalObject.brandModelId);
      this.selectDefaults.brandModel = selectedModel;
      this.vehicle.brandModelId = selectedModel.brandModelId;

      this.vehicle.variant = item.originalObject.variant;

      let vehicleType = _find(this.enumLookupCollection['vehicleType'], o => o.id === item.originalObject.vehicleTypeE);
      this.selectDefaults.vehicleType = vehicleType;
      this.vehicle.vehicleType = vehicleType.id;

      if (item.originalObject.bodyTypeE) {
        let bodyType = _find(this.enumLookupCollection['vehicleBodyType'], o => o.id === item.originalObject.bodyTypeE);
        this.selectDefaults.vehicleBodyType = bodyType;
        this.vehicle.vehicleBodyType = bodyType.id;
      }

      if (item.originalObject.transmissionTypeE) {
        let transmissionType = _find(this.enumLookupCollection['transmissionType'], o => o.id === item.originalObject.transmissionTypeE);
        this.selectDefaults.transmissionType = transmissionType;
        this.vehicle.transmissionType = transmissionType.id;
      }

      if (item.originalObject.fuelTypeE) {
        let fuelType = _find(this.enumLookupCollection['fuelType'], o => o.id === item.originalObject.fuelTypeE);
        this.selectDefaults.fuelType = fuelType;
        this.vehicle.fuelType = fuelType.id;
      }
    }
  }

  clearVehicle() {
    this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchVehicle');

    this.vehicle.variant = null;
    this.initializeLookups(true).then(() => {
      this.initializeEnumLookups();
    });
  }
}

export default VehicleInformationController;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleEdit/vehicleInformation/vehicleInformation.controller.js